import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacUIButton, PnmacText, PnmacPageBubble, PnmacAppBar, PnmacMediaQuery, PnmacMeta, LocalStorage } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { LOG_OUT } from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
var SuccessfulLogout = /** @class */function (_super) {
  __extends(SuccessfulLogout, _super);
  function SuccessfulLogout(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  SuccessfulLogout.prototype.componentDidMount = function () {
    this.props.ui_data();
    this.props.dispatch({
      type: LOG_OUT,
      logedIn: false
    });
    var env = window.location.host.indexOf("-") > -1 || window.location.host.indexOf("localhost") > -1;
    if (env) {
      var lower = document.createElement("script");
      lower.setAttribute("src", "https://assets.adobedtm.com/c52783cec8b1/b490159dbd62/launch-7d7413fb35dc-staging.min.js");
      lower.setAttribute("async", "true");
      lower.setAttribute("id", "marketing-script");
      document.head.appendChild(lower);
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=RtGTTXbB38F13mRO6ftcNA&gtm_preview=env-3&gtm_cookies_win=x';
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-T8X4NKQ');
      var noscpt = document.createElement("noscript");
      noscpt.setAttribute("src", "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-T8X4NKQ\"\n                    height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
      noscpt.setAttribute("id", "GTM-T8X4NKQ");
      document.body.appendChild(noscpt);
    } else {
      var prd = document.createElement("script");
      prd.setAttribute("src", "https://assets.adobedtm.com/c52783cec8b1/b490159dbd62/launch-830b0903b192.min.js");
      prd.setAttribute("async", "true");
      prd.setAttribute("id", "marketing-script");
      document.head.appendChild(prd);
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=KzvPz0hamqThFtaqlDkhHg&gtm_preview=env-1&gtm_cookies_win=x';
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-T8X4NKQ');
      var noscpt = document.createElement("noscript");
      noscpt.setAttribute("src", "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-T8X4NKQ\"\n                    height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
      noscpt.setAttribute("id", "GTM-T8X4NKQ");
    }
  };
  SuccessfulLogout.prototype.render = function () {
    var _a = this.props,
      translations = _a.translations,
      layout = _a.layout;
    var enabled = !layout.loading;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacAppBar, {
        style: {
          elevation: 0,
          backgroundColor: '#FFFFF',
          height: 75,
          alignItems: matches.small ? undefined : "center",
          display: "flex",
          flexDirection: matches.small ? 'column' : 'row',
          marginTop: matches.small ? 20 : 0
        },
        right: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flex: 1,
          marginLeft: 20
        }
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Pennyhome logo",
        style: {
          height: 30,
          width: 260
        },
        src: require("../assets/IDSPennyHomeLogoInterstitial.svg")
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          marginLeft: matches.small ? 15 : 0
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        style: {
          marginRight: 20
        },
        onClick: function () {
          window.location.href = "/account/login";
          LocalStorage.removeItem("PennyWindowUnloadTime");
        }
      }, translations.LoginPartialLogIn), /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        style: {
          marginRight: 20
        },
        onClick: function () {
          window.location.href = "/account/register";
          LocalStorage.removeItem("PennyWindowUnloadTime");
        }
      }, translations.Register))), /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.SuccessfulLogoutText
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        accessibilityRole: "header",
        ariaLevel: "1",
        containerStyles: {
          padding: 0,
          marginTop: 10
        },
        text: translations.SuccessfulLogoutText
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 20,
          marginBottom: 40,
          display: "flex",
          flexDirection: matches.small || matches.medium ? "column" : "row"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: 20,
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("img", {
        alt: "LogOut image",
        style: {
          marginTop: 25,
          marginBottom: 10,
          width: '100%'
        },
        src: require('../assets/LogOut_img.png')
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small || matches.medium ? 0 : 25,
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: translations.LogOutPutYourEquity
        },
        style: {
          color: "#003087"
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: translations.LogOutMessage
        },
        style: {
          width: '100%',
          paddingRight: 10
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10,
          display: "flex",
          flexDirection: matches.small ? 'column' : 'row',
          marginRight: 30
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        disabled: !enabled,
        uppercase: false,
        mode: "contained",
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: '50%',
          marginTop: 15
        },
        onPress: function () {
          window.open("tel:8889782075", "_blank");
        }
      }, translations === null || translations === void 0 ? void 0 : translations.CallNumberText), /*#__PURE__*/React.createElement(PnmacUIButton, {
        disabled: !enabled,
        uppercase: false,
        mode: "contained",
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: '50%',
          marginTop: 15,
          marginLeft: matches.small ? 0 : 15
        },
        onPress: function () {
          window.open("https://www.pennymac.com/mortgage-rates?port=true", "_blank");
        }
      }, translations === null || translations === void 0 ? void 0 : translations.GetStartedText)), /*#__PURE__*/React.createElement("div", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: translations.ReturnToHomePage
        }
      }))));
    });
  };
  return SuccessfulLogout;
}(Component);
export { SuccessfulLogout };
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(SuccessfulLogout);